import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import _ from 'lodash';
import Modal from 'scy/Modal';
import LoadingSpinner from 'scy/LoadingSpinner';
import { PaymentLogoList } from 'scy/PaymentLogo';
import PaymentMethodForm from '../payment/form';
import { makePrimaryCard, removeCard } from '../payment/actions';
import PaymentLogo from 'scy/PaymentLogo';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { Body, SmallUppercase, H5 } from 'scy/text';
import { mutedAccent, secondary } from 'scy/text/styles.mod.scss';
import {
  flex,
  flex1,
  flexGrow1,
  flexShrink0,
  centerItems
} from 'scy/flex.mod.scss';
import { tablet_hidden, hidden, tablet_inline } from 'scy/display.mod.scss';
import border from 'scy/border.mod.scss';
import { plainList, width100 } from 'scy/utils.mod.scss';
import {
  TextButton,
  PrimaryButton,
  AltPrimaryButton,
  AltSecondaryButton
} from 'scy/buttons';
import { LightBackground } from 'scy/Background';

function CardRow({ brand, last4, isPrimary, makePrimary, remove }) {
  return (
    <li className={classnames(flex, centerItems)}>
      <PaymentLogo brand={brand} />

      <div
        className={classnames(
          margin.left_sm,
          padding.top_sm,
          padding.bottom_sm,
          border.bottomMedium,
          flex1,
          flex,
          centerItems
        )}
      >
        <Body className={classnames(flexGrow1, flexShrink0)}>
          <span className={tablet_hidden}>••••</span>
          <span className={classnames(hidden, tablet_inline)}>
            {brand}
          </span>{' '}
          {last4}
        </Body>

        <SmallUppercase
          tag="div"
          className={classnames(
            padding.xs,
            isPrimary ? mutedAccent : secondary
          )}
        >
          {isPrimary ? (
            'Primary'
          ) : (
            <TextButton noUnderline onClick={makePrimary}>
              Make Primary
            </TextButton>
          )}
        </SmallUppercase>

        <SmallUppercase tag="div" className={padding.xs}>
          <TextButton onClick={remove}>Delete</TextButton>
        </SmallUppercase>
      </div>
    </li>
  );
}

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, loading: false, cardToDelete: null };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.makePrimary = this.makePrimary.bind(this);
    this.remove = this.remove.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
    this.closeRemoveModal = this.closeRemoveModal.bind(this);
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  makePrimary(id) {
    this.setState({ loading: true });
    this.props.makePrimaryCard(id).finally(() => {
      this.setState({ loading: false });
    });
  }

  remove(card) {
    this.setState({ cardToDelete: card });
  }

  confirmRemove() {
    this.setState({ loading: true });
    this.props.removeCard(this.state.cardToDelete.id).finally(() => {
      this.setState({ loading: false, cardToDelete: null });
    });
  }

  closeRemoveModal() {
    this.setState({ cardToDelete: null });
  }

  render() {
    const primaryCard = this.props.primaryCardId
      ? _.find(this.props.cards, { id: this.props.primaryCardId })
      : _.first(this.props.cards);

    return (
      <>
        {this.state.loading && <LoadingSpinner black backdrop />}

        {!!(this.props.cards || []).length && (
          <ul className={`${plainList} ${margin.bottom_md}`}>
            {this.props.cards.map(card => (
              <CardRow
                key={card.id}
                brand={card.brand}
                last4={card.last4}
                isPrimary={primaryCard && primaryCard.id === card.id}
                makePrimary={() => this.makePrimary(card.id)}
                remove={() => this.remove(card)}
              />
            ))}
          </ul>
        )}

        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-0">
            <PrimaryButton
              type="button"
              className={width100}
              onClick={this.openModal}
            >
              Add Card
            </PrimaryButton>
          </div>
        </div>

        <Modal
          isOpen={this.state.showModal}
          handleClose={this.closeModal}
          contentLabel="Payment Info"
          size="small"
        >
          <LightBackground
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.left_sm,
              padding.right_sm
            )}
          >
            <H5 uppercase tag="h2" marginClass={margin.bottom_sm}>
              Payment Info
            </H5>
            <PaymentLogoList
              className={classnames(flex, margin.bottom_sm)}
              itemClassName={margin.right_xxs}
            />
            <PaymentMethodForm
              onSuccess={this.closeModal}
              btnContainerClass="col-xs-12 col-md-5 col-md-offset-7"
            />
          </LightBackground>
        </Modal>

        <Modal
          isOpen={!!this.state.cardToDelete}
          handleClose={this.closeRemoveModal}
          contentLabel="Remove Credit Card"
        >
          <LightBackground
            className={classnames(padding.top_md, padding.bottom_sm)}
          >
            {this.state.cardToDelete && (
              <Body
                marginClass={classnames(margin.sm, margin.tablet_md)}
                tag="p"
              >
                Are you sure you want to remove <br />
                {this.state.cardToDelete.brand} {this.state.cardToDelete.last4}?
              </Body>
            )}

            <div className={classnames(margin.sm, margin.tablet_md)}>
              <AltSecondaryButton
                className={margin.right_sm}
                onClick={this.closeRemoveModal}
              >
                Cancel
              </AltSecondaryButton>
              <AltPrimaryButton onClick={this.confirmRemove}>
                Confirm
              </AltPrimaryButton>
            </div>
          </LightBackground>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.payment };
}

export default connect(
  mapStateToProps,
  { makePrimaryCard, removeCard }
)(Payment);
